/* eslint-disable react/jsx-no-target-blank */
import {useIntl} from 'react-intl'
import {KTIcon} from '../../../helpers'
import {AsideMenuItemWithSub} from './AsideMenuItemWithSub'
import {AsideMenuItem} from './AsideMenuItem'
import { useAuth} from '../../../../app/modules/auth'
import { useCallback, useEffect, useState } from 'react'
import { getUserByToken } from '../../../../app/modules/auth/core/_requests'
import { MenuComponent } from '../../../assets/ts/components'
import { useLocation } from 'react-router-dom'
import axios from 'axios'
import { URLSearchParams } from 'url'
import { checkError } from '../../../../app/modules/globallycommanFunctions/commanfunction'
import { useQueryClient } from 'react-query'
import { useSelector } from 'react-redux'
const API_URL = process.env.REACT_APP_KT_API_URL
const tokenString: any = localStorage.getItem('kt-auth-react-v')
const token = JSON.parse(tokenString)

export function AsideMenuMain() {
  const intl = useIntl()
  const {currentUser,setCurrentUser,logout,saveAuth} = useAuth()
  // const {pathname} = useLocation()
  const [domButtonClicked, setDomButtonClicked] = useState(false)
  const [getTokenfromlocalstorage, setGetTokenfromlocalstorage] = useState(null)
  
  const queryClient = useQueryClient()
  const isBuyerView: boolean = useSelector((state: any) => state.buyerViewSwitch.isBuyerView)

  // console.log("currentUser?.roles", currentUser?.roles)

//   useEffect(() => {
//   const handleClick = (event: MouseEvent) => {
//     const el = event.target as HTMLElement;

//     // Use .closest() to detect clicks inside buttons or anchors
//     const button = el.closest("button");
//     const anchor = el.closest("a.menu-link");

//     // Only trigger state update if we actually clicked a relevant element
//     if (button || anchor) {
//       setDomButtonClicked(prev => !prev);
//       // console.log("Clicked element:", button || anchor);
//     }
//   };
//   // Attach listener once
//   document.addEventListener("click", handleClick);

//   // Clean up on unmount
//   return () => {
//     document.removeEventListener("click", handleClick);
//   };
// }, []); // 👈 empty dependency = listener added only once

//     useEffect(() => {
//     if(!getTokenfromlocalstorage) return
//     const fetchUser = async () => {
//       try {
//       // const userData:any =  await getUserByToken();
//           const userData:any = await axios.get(`${API_URL}/auth/verify-token`, {
//           headers: {"Authorization": `Bearer ${token?.access_token}`,},
//           });
//           console.log("userData", userData)
//           if(userData?.data?.statusCode === 200){
//         if(!userData?.data?.data?.status){
//           localStorage.removeItem('microsoftAzure')
//           localStorage.removeItem('azureLogoutcredential')
//           localStorage.removeItem("newChannelAddedprompt");
//           localStorage.removeItem("StopAPIRequest");
//           localStorage.removeItem("SellercloudchannelStatus");
//           localStorage.removeItem("StopAPIRequest");
//           localStorage.removeItem("priceScrapfilterdata");
//           saveAuth(undefined)
//           setCurrentUser(undefined)
//           logout('false')
//         }
//       }
//       } catch (error) {
//         // checkError(error, logout);
//       }
//     };
  
//     fetchUser();
//   }, [domButtonClicked]);



  // console.log("gycgsdgd", currentUser?.hasPermission('can-view-products'))

  //   console.log("dgshsdgh", currentUser)

  const dashboardMenuItem = (currentUser && currentUser?.roles && currentUser?.roles?.length > 0) &&
      (currentUser?.roles?.[0].id === 1 || currentUser?.roles?.[0].id === 2 || currentUser?.roles?.[0].id === 3) &&
      <AsideMenuItem
        to='/dashboard'
        icon='element-11'
        title={intl.formatMessage({id: 'MENU.DASHBOARD'})}
        onClick={() => {
          queryClient.invalidateQueries({
            predicate: (query) => 
              query.queryKey[0] === 'totalProducts' || 
              query.queryKey[0] === 'totalPriceMappingFeed' || 
              query.queryKey[0] === 'lastProduct' || 
              query.queryKey[0] === 'totalBuyers' || 
              query.queryKey[0] === 'totalAdmins' || 
              query.queryKey[0] === 'newCard'
          })
        }}
      />

  // Buyer view (header switch on): only show the tabs a Buyer uses
  if (isBuyerView) {
    return (
      <>
        {dashboardMenuItem}
        <div className='menu-item'>
          <div className='menu-content pt-8 pb-2'>
            <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Pricing Tool</span>
          </div>
        </div>
        <AsideMenuItem to='allProducts/list' icon='all-product-icon' title='All Products' />
        <AsideMenuItem to='manage-product-listing/list' icon='product-management-list' title='Manage Product Listings' />
      </>
    )
  }

  return (
    <>
    {dashboardMenuItem}


      {/* OLD Mange Role start */}
      {/* {currentUser?.hasPermission('can-view-roles') && ( */}
      {/* {(currentUser && currentUser?.roles && currentUser?.roles?.length > 0) &&
      (currentUser?.roles?.[0].id === 1 || currentUser?.roles?.[0].id === 2) &&
        <>
          <div className='menu-item'>
            <div className='menu-content pt-8 pb-2'>
              <span className='menu-section text-muted text-uppercase fs-8 ls-1'>
                Authorization
              </span>
            </div>
          </div>
          <AsideMenuItem to='roles/list' icon='shield-tick' title='Manage Roles' />
        </>
     } */}
      {/* )} */}

      {/* NEW Mange Role end */}
      {currentUser?.hasPermission('can-view-roles') && (
        <>
          <div className='menu-item'>
            <div className='menu-content pt-8 pb-2'>
              <span className='menu-section text-muted text-uppercase fs-8 ls-1'>
                Authorization
              </span>
            </div>
          </div>
          <AsideMenuItem to='roles/list' icon='manage-roles' title='Manage Roles' />
        </>
      )
     }
 



    {/* OLD User Management  start */}
      {/* {(currentUser?.hasPermission('can-view-users') ||
        currentUser?.hasPermission('can-view-buyers')) && ( */}
    {/* {(currentUser && currentUser?.roles && currentUser?.roles?.length > 0) &&
      (currentUser?.roles?.[0].id === 1 || currentUser?.roles?.[0].id === 2) &&

        <div className='menu-item'>
          <div className='menu-content pt-8 pb-2'>
            <span className='menu-section text-muted text-uppercase fs-8 ls-1'>
              User Management
            </span>
          </div>
        </div>
     } */}
      {/* )} */}

    {/* OLD User Management  END */}

   {/* NEW User Management */}
      {(currentUser?.hasPermission('can-view-users') ||
        currentUser?.hasPermission('can-view-buyers')) && (
           <>
        <div className='menu-item'>
          <div className='menu-content pt-8 pb-2'>
            <span className='menu-section text-muted text-uppercase fs-8 ls-1'>
              User Management
            </span>
          </div>
        </div>
        </>
        )
     }
       {/* NEW User Management END */}


    {/* OLD Manage Buyer Start*/}
      {/* {currentUser?.hasPermission('can-view-buyers') && ( */}
      {/* {(currentUser && currentUser?.roles && currentUser?.roles?.length > 0) &&
      (currentUser?.roles?.[0].id === 1 || currentUser?.roles?.[0].id === 2) &&
        <AsideMenuItem to='buyers/list' icon='shield-tick' title='Manage Buyer' />
      } */}
      {/* )} */}
          {/* OLD Manage Buyer END*/}



    {/* NEW Manage Buyer Start*/}
     {currentUser?.hasPermission('can-view-buyers') && (
        <AsideMenuItem to='buyers/list' icon='manage-buyers' title='Manage Buyer' />
     )}
    {/* NEW Manage Buyer END*/}



       {/* OLD Manage Users Start */}
      {/* {(currentUser && currentUser?.roles && currentUser?.roles?.length > 0) &&
      (currentUser?.roles?.[0].id === 1 || currentUser?.roles?.[0].id === 2) &&
      // currentUser?.hasPermission('can-view-users') &&
      
       (
        <AsideMenuItem to='users/list' icon='shield-tick' title='Manage Users' />
      
        )} */}
        {/* OLD Manage Users End */}

       {/* NEW Manage Users Start */}
      {
      currentUser?.hasPermission('can-view-users') && 
       (
        <AsideMenuItem to='users/list' icon='user' title='Manage Users' />
        )}
        {/* NEW Manage Users End */}








      {/*<AsideMenuItem to='/builder' icon='switch' title='Layout Builder' />*/}
      {/*<div className='menu-item'>*/}
      {/*  <div className='menu-content pt-8 pb-2'>*/}
      {/*    <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Crafted</span>*/}
      {/*  </div>*/}
      {/*</div>*/}
      {/*<AsideMenuItemWithSub to='/crafted/pages' title='Pages' icon='gift'>*/}
      {/*  <AsideMenuItemWithSub to='/crafted/pages/profile' title='Profile' hasBullet={true}>*/}
      {/*    <AsideMenuItem to='/crafted/pages/profile/overview' title='Detail' hasBullet={true} />*/}
      {/*    <AsideMenuItem to='/crafted/pages/profile/projects' title='Projects' hasBullet={true} />*/}
      {/*    <AsideMenuItem to='/crafted/pages/profile/campaigns' title='Campaigns' hasBullet={true} />*/}
      {/*    <AsideMenuItem to='/crafted/pages/profile/documents' title='Documents' hasBullet={true} />*/}
      {/*    <AsideMenuItem*/}
      {/*      to='/crafted/pages/profile/connections'*/}
      {/*      title='Connections'*/}
      {/*      hasBullet={true}*/}
      {/*    />*/}
      {/*  </AsideMenuItemWithSub>*/}

      {/*  <AsideMenuItemWithSub to='/crafted/pages/wizards' title='Wizards' hasBullet={true}>*/}
      {/*    <AsideMenuItem*/}
      {/*      to='/crafted/pages/wizards/horizontal'*/}
      {/*      title='Horizontal'*/}
      {/*      hasBullet={true}*/}
      {/*    />*/}
      {/*    <AsideMenuItem to='/crafted/pages/wizards/vertical' title='Vertical' hasBullet={true} />*/}
      {/*  </AsideMenuItemWithSub>*/}
      {/*</AsideMenuItemWithSub>*/}
      {/*<AsideMenuItemWithSub to='/crafted/accounts' title='Accounts' icon='profile-circle'>*/}
      {/*  <AsideMenuItem to='/account/overview' title='Detail' hasBullet={true} />*/}
      {/*  <AsideMenuItem to='/account/settings' title='Settings' hasBullet={true} />*/}
      {/*</AsideMenuItemWithSub>*/}
      {/*<AsideMenuItemWithSub to='/error' title='Errors' icon='cross-circle'>*/}
      {/*  <AsideMenuItem to='/error/404' title='Error 404' hasBullet={true} />*/}
      {/*  <AsideMenuItem to='/error/500' title='Error 500' hasBullet={true} />*/}
      {/*</AsideMenuItemWithSub>*/}
      {/*<AsideMenuItemWithSub to='/crafted/widgets' title='Widgets' icon='element-plus'>*/}
      {/*  <AsideMenuItem to='/crafted/widgets/lists' title='Lists' hasBullet={true} />*/}
      {/*  <AsideMenuItem to='/crafted/widgets/statistics' title='Statistics' hasBullet={true} />*/}
      {/*  <AsideMenuItem to='/crafted/widgets/charts' title='Charts' hasBullet={true} />*/}
      {/*  <AsideMenuItem to='/crafted/widgets/mixed' title='Mixed' hasBullet={true} />*/}
      {/*  <AsideMenuItem to='/crafted/widgets/tables' title='Tables' hasBullet={true} />*/}
      {/*  <AsideMenuItem to='/crafted/widgets/feeds' title='Feeds' hasBullet={true} />*/}
      {/*</AsideMenuItemWithSub>*/}
      {/*<div className='menu-item'>*/}
      {/*  <div className='menu-content pt-8 pb-2'>*/}
      {/*    <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Apps</span>*/}
      {/*  </div>*/}
      {/*</div>*/}
      {/*<AsideMenuItemWithSub to='/apps/chat' title='Chat' icon='message-text-2'>*/}
      {/*  <AsideMenuItem to='/apps/chat/private-chat' title='Private Chat' hasBullet={true} />*/}
      {/*  <AsideMenuItem to='/apps/chat/group-chat' title='Group Chart' hasBullet={true} />*/}
      {/*  <AsideMenuItem to='/apps/chat/drawer-chat' title='Drawer Chart' hasBullet={true} />*/}
      {/*</AsideMenuItemWithSub>*/}

      {/* {currentUser?.hasPermission('can-view-channels') && ( */}
      
        {/* <div className='menu-item'>
          <div className='menu-content pt-8 pb-2'>
            <span className='menu-section text-muted text-uppercase fs-8 ls-1'>
              Profit Margin Tool
            </span>
          </div>
        </div> */}
      {/* )} */}
       {/* {currentUser?.hasPermission('can-view-products-pricing') && ( */}
        {/* <AsideMenuItem to='all-Products/list' icon='shield-tick' title='All Products' /> */}
      {/* )} */}

      {/* {currentUser?.hasPermission('can-view-channels') && ( */}
      {/* {(currentUser && currentUser?.roles && currentUser?.roles?.length > 0) &&
      (currentUser?.roles?.[0].id === 1 || currentUser?.roles?.[0].id === 2) &&
        <AsideMenuItem to='channels/list' icon='shield-tick' title='Manage Channels' />
      } */}
      {/* )} */}

      {/* {currentUser?.hasPermission('can-view-products') && ( */}
      {/* {(currentUser && currentUser?.roles && currentUser?.roles?.length > 0) &&
      (currentUser?.roles?.[0].id === 1 || currentUser?.roles?.[0].id === 2) &&
        <AsideMenuItem to='products/list' icon='shield-tick' title='Manage Products' />
      } */}
      {/* )} */}
      
       {/* {currentUser?.hasPermission('can-view-products') && (
        <AsideMenuItem to='ibs-product/list' icon='shield-tick' title='IBS Products' />
      )} */}

      {/* {currentUser?.hasPermission('can-synchronize-products') && (
        <AsideMenuItem to='ibs-products-sync/list' icon='shield-tick' title='IBS Product Sync' />
      )} */}

      {/* currently it is not working because we have no permission for this */}
      {/* {currentUser?.hasPermission('can-view-amazon-accounts') && (
        <AsideMenuItem to='aws/accounts' icon='shield-tick' title='Manage Account' />
      )} */}

      {/* {currentUser?.hasPermission('can-synchronize-products') && (
        <AsideMenuItem to='amazon/products' icon='shield-tick' title='Associate Products' />
      )} */}

      {/* {currentUser?.hasPermission('can-view-amazon-accounts') && (
        <AsideMenuItem to='aws/accounts' icon='shield-tick' title='Manage Account' />
      )} */}

      {/* <AsideMenuItem to='currency/list' icon='shield-tick' title='Manage Currency Exchange' /> */}

      {
        // currentUser?.hasPermission('can-view-products-pricing') &&
        // currentUser?.hasPermission('can-view-amazon-accounts') && (
          <div className='menu-item'>
            <div className='menu-content pt-8 pb-2'>
              <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Pricing Tool</span>
            </div>
          </div>
        // )
      }

     
           {/* {currentUser?.hasPermission('can-view-products-pricing') && ( */}
        <AsideMenuItem to='allProducts/list' icon='all-product-icon' title='All Products' />
      {/* )} */}

        {/* <AsideMenuItem to='new-all-products/list' icon='all-product-icon' title='New All Products' /> */}
     {(currentUser && currentUser?.roles && currentUser?.roles?.length > 0) &&
      (currentUser?.roles?.[0].id === 1 || currentUser?.roles?.[0].id === 2) &&
             <AsideMenuItem to='manage-product-listing/list' icon='product-management-list' title='Manage Product Listings' />
        }
             
           {(currentUser && currentUser?.roles && currentUser?.roles?.length > 0) &&
            (currentUser?.roles?.[0].id === 1 || currentUser?.roles?.[0].id === 2) &&
             <AsideMenuItem to='alerts-settings/list' icon='notification-on' title='Alerts Settings' />
          } 
      
      {/* {currentUser?.hasPermission('can-view-products-pricing') && (
        <AsideMenuItem to='amazon/products' icon='shield-tick' title='Associate Products' />
      )} */}


     {/* OLD AMAZON ACCOUNT START */}
      {/* {currentUser?.hasPermission('can-view-amazon-accounts') && ( */}
      {/* {(currentUser && currentUser?.roles && currentUser?.roles?.length > 0) &&
      (currentUser?.roles?.[0].id === 1 || currentUser?.roles?.[0].id === 2) &&
        <AsideMenuItem to='aws/accounts' icon='shield-tick' title='Amazon Accounts' />
      } */}
      {/* )} */}
      {/* OLD AMAZON ACCOUNT END */}


     {/* NEW AMAZON ACCOUNT START */}
      {/* {currentUser?.hasPermission('can-view-amazon-accounts') && ( */}

          {(currentUser && currentUser?.roles && currentUser?.roles?.length > 0) &&
      (currentUser?.roles?.[0].id === 1 || currentUser?.roles?.[0].id === 2) &&
        <AsideMenuItem to='aws/accounts' icon='profile-circle' title='Amazon Accounts' />
      }
      {(currentUser && currentUser?.roles && currentUser?.roles?.length > 0) &&
      (currentUser?.roles?.[0].id === 1 || currentUser?.roles?.[0].id === 2) &&
        <AsideMenuItem to='amazon-seller/list' icon='shop' title='Amazon Sellers' />
      }
      {/* NEW AMAZON ACCOUNT END */}


         {/* {currentUser?.hasPermission('can-view-seller-account') && (
        <AsideMenuItem to='seller-account/list' icon='shield-tick' title='Seller Account' />
      )} */}

      {/* {currentUser?.hasPermission('can-view-products-pricing') && ( */}


      {/* OLD Amazon Products START */}
      {(currentUser && currentUser?.roles && currentUser?.roles?.length > 0) &&
      (currentUser?.roles?.[0].id === 1 || currentUser?.roles?.[0].id === 2) &&
        <AsideMenuItem to='amazon-product/list' icon='product-icon' title='Amazon Products' />
      }
          {/* )} */}
          {/* OLD Amazon Products END */}


      {/*NEW Amazon Products START */}
      {/* { currentUser?.hasPermission('can-view-product') && 
        <AsideMenuItem to='amazon-product/list' icon='shield-tick' title='Amazon Products' />
      } */}
          {/* )} */}
          {/* NEW Amazon Products END */}
   

      {/* {currentUser?.hasPermission('can-view-products-pricing') && ( */}
      {(currentUser && currentUser?.roles && currentUser?.roles?.length > 0) &&
      (currentUser?.roles?.[0].id === 1 || currentUser?.roles?.[0].id === 2) &&
        <AsideMenuItem to='seller-product/list' icon='product-icon' title='Sellercloud Products'/>
      }
      {/* )} */}


      
         {/* {currentUser?.hasPermission('can-view-products-pricing') && ( */}
         {(currentUser && currentUser?.roles && currentUser?.roles?.length > 0) &&
      (currentUser?.roles?.[0].id === 1 || currentUser?.roles?.[0].id === 2) &&
        <AsideMenuItem to='goflow-Product/list' icon='product-icon' title='Goflow Products' />
         }
       {/* )}  */}


  

        {/* {currentUser?.hasPermission('can-view-products-pricing') && ( */}
        {(currentUser && currentUser?.roles && currentUser?.roles?.length > 0) &&
      (currentUser?.roles?.[0].id === 1 || currentUser?.roles?.[0].id === 2) &&
        <AsideMenuItem to='channel-setting/list' icon='setting-2' title='Channel Settings' />
         }

{(currentUser && currentUser?.roles && currentUser?.roles?.length > 0) &&
      (currentUser?.roles?.[0].id === 1 || currentUser?.roles?.[0].id === 2) &&
        // <AsideMenuItem to='price-mapping/list' icon='price-mapping-settings' title='Price Mapping Settings' />
           <AsideMenuItem to='price-mapping/list' icon='price-mapping-settings' title='Price Mapping Settings' />
         }

  {/* ENABLED LOGS FOR ONLY SUPER ADMIN */}
              {/* {currentUser?.hasPermission('can-view-products-pricing') && ( */}
       {/* { currentUser &&  currentUser?.roles && currentUser?.roles?.length >  0  && currentUser?.roles?.[0].id === 1 && (
       <AsideMenuItem to='logs/list' icon='shield-tick' title='Logs' />
       )
        } */}


        {/* BOTH ENABLE LOGS FOR ADMIN/SUPER ADMIN */}
        {(currentUser && currentUser?.roles && currentUser?.roles?.length > 0) &&
      (currentUser?.roles?.[0].id === 1 || currentUser?.roles?.[0].id === 2) &&
      <AsideMenuItem to='logs/list' icon='logs' title='Logs' />
         }


         {/* { currentUser &&  currentUser?.roles && currentUser?.roles?.length >  0  && currentUser?.roles?.[0].id === 1 && (
       <AsideMenuItem to='logs/list' icon='shield-tick' title='Logs' />
       )
        } */}
       {/* )}  */}


       {/* )}  */}

      {/* <AsideMenuItem
          to='seller-Cloud'
          icon='shield-tick'
          title='Seller Account'
        /> */}

      {/* {currentUser?.hasPermission('can-view-products') && (
        <AsideMenuItem to='products/list' icon='shield-tick' title='All Products' />
      )} */}

      {/*only for design*/}

      {/* <div className='menu-item'>
            <div className='menu-content pt-8 pb-2'>
                <span className='menu-section text-muted text-uppercase fs-8 ls-1'>AMAZON PRODUCTS (DESIGN)</span>
            </div>
        </div> */}
      {/* <AsideMenuItem to='/apps/IBS-product-sync/IBS-product-sync' icon='shield-tick' title='IBS Product Sync (DESIGN)' />

      <div className='menu-item'>
            <div className='menu-content pt-8 pb-2'>
                <span className='menu-section text-muted text-uppercase fs-8 ls-1'>PRODUCTS (DESIGN)</span>
            </div>
        </div>
      <AsideMenuItem to='/apps/products/all-products' icon='shield-tick' title='Manage Products (DESIGN)' />

      <AsideMenuItem to='/apps/create-sale-pricing/create-sale-pricing' icon='shield-tick' title='All Product (DESIGN)' /> */}

      {/*<AsideMenuItem to='/apps/user-management/users' icon='shield-tick' title='User management' />*/}

      {/*<div className='menu-item'>*/}
      {/*  <div className='menu-content'>*/}
      {/*    <div className='separator mx-1 my-4'></div>*/}
      {/*  </div>*/}
      {/*</div>*/}
      {/*<div className='menu-item'>*/}
      {/*  <a*/}
      {/*    target='_blank'*/}
      {/*    className='menu-link'*/}
      {/*    href={process.env.REACT_APP_PREVIEW_DOCS_URL + '/docs/changelog'}*/}
      {/*  >*/}
      {/*    <span className='menu-icon'>*/}
      {/*      <KTIcon iconName='document' className='fs-2' />*/}
      {/*    </span>*/}
      {/*    <span className='menu-title'>Changelog {process.env.REACT_APP_VERSION}</span>*/}
      {/*  </a>*/}
      {/*</div>*/}
    </>
  )
}
